import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const ManufacturingERPPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Manufacturing ERP Solutions | AquarLabs</title>
                <meta name="description" content="Optimize your manufacturing operations with AquarLabs' ERP solutions. Streamline production planning, inventory management, quality control, and shop floor operations." />
                <meta name="keywords" content="manufacturing ERP, production planning, inventory management, MRP, shop floor control, quality management, manufacturing software, AquarLabs" />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Manufacturing ERP Solutions" pagesub="Manufacturing ERP" parentPage="Solutions" parentLink="/service" />

                        {/* Hero Section */}
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>Manufacturing ERP Solutions</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Revolutionize your manufacturing operations with intelligent ERP solutions. From production planning to quality control, we help you achieve operational excellence and competitive advantage.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Overview Section */}
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>End-to-End Manufacturing Intelligence</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs' Manufacturing ERP solutions provide complete visibility and control over your production processes. Our platform integrates material requirements planning (MRP), shop floor execution, quality management, and maintenance operations into a unified system.
                                </p>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)", marginTop: "20px" }}>
                                    Leverage real-time data, predictive analytics, and IoT integration to optimize throughput, reduce waste, and deliver products on time. Whether you operate discrete, process, or mixed-mode manufacturing, our solutions adapt to your unique requirements.
                                </p>
                            </div>
                        </section>

                        {/* Services Section */}
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Our Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Complete Manufacturing Suite</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                {
                                                    title: "Production Planning",
                                                    desc: "Intelligent scheduling and capacity optimization.",
                                                    items: ["MRP/MRP II Implementation", "Finite Capacity Scheduling", "Demand Forecasting"]
                                                },
                                                {
                                                    title: "Shop Floor Control",
                                                    desc: "Real-time visibility into production operations.",
                                                    items: ["Work Order Management", "Machine Monitoring", "Labor Tracking"]
                                                },
                                                {
                                                    title: "Quality Management",
                                                    desc: "Ensure product quality at every stage.",
                                                    items: ["Inspection Management", "Non-Conformance Tracking", "SPC & Statistical Analysis"]
                                                },
                                                {
                                                    title: "Inventory & Warehouse",
                                                    desc: "Optimize material flow and storage.",
                                                    items: ["Bill of Materials (BOM)", "Lot & Serial Tracking", "Warehouse Management"]
                                                }
                                            ].map((activity, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}>
                                                            <span style={{ color: "#fc9038" }}>●</span> {activity.title}
                                                        </h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)", marginBottom: "15px" }}>{activity.desc}</p>
                                                        <ul style={{ listStyle: "none", padding: 0 }}>
                                                            {activity.items.map((item, i) => (
                                                                <li key={i} style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", padding: "5px 0" }}>→ {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Why Us Section */}
                        <section style={{ padding: "80px 0", background: "#0a0a0a" }}>
                            <div className="container">
                                <div className="text-center" style={{ marginBottom: "50px" }}>
                                    <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Why Us</span>
                                    <h2 style={{ fontSize: "2.5rem", margin: "15px 0 20px", color: "#fff" }}>Why Choose AquarLabs for Manufacturing ERP?</h2>
                                    <p style={{ fontSize: "1rem", color: "rgba(255,255,255,0.6)", maxWidth: "700px", margin: "0 auto" }}>
                                        Deep manufacturing expertise combined with modern technology innovation.
                                    </p>
                                </div>
                                <div className="row">
                                    {[
                                        { title: "Industry 4.0 Ready", desc: "IoT integration, digital twins, and smart factory capabilities." },
                                        { title: "Reduce Lead Times", desc: "Typical clients see 30-50% improvement in delivery performance." },
                                        { title: "Minimize Waste", desc: "Lean manufacturing principles embedded in system design." },
                                        { title: "Real-Time Visibility", desc: "Dashboards and alerts for instant operational insights." },
                                        { title: "Flexible Configuration", desc: "Adapt to discrete, process, or hybrid manufacturing models." },
                                        { title: "Proven Track Record", desc: "Successful implementations across automotive, electronics, and more." }
                                    ].map((item, index) => (
                                        <div key={index} className="col-lg-6" style={{ marginBottom: "20px" }}>
                                            <div style={{
                                                background: "rgba(20, 20, 20, 0.8)",
                                                border: "1px solid rgba(252, 144, 56, 0.4)",
                                                borderRadius: "16px",
                                                padding: "28px 30px",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "15px"
                                            }}>
                                                <div style={{
                                                    minWidth: "40px",
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    background: "rgba(252, 144, 56, 0.1)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M2 17L12 22L22 17" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M2 12L12 17L22 12" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <h3 style={{ fontSize: "1.1rem", color: "#fff", marginBottom: "8px", fontWeight: "600" }}>{item.title}</h3>
                                                    <p style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", margin: 0, lineHeight: "1.6" }}>{item.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* CTA Section */}
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Optimize Your Manufacturing</h2>
                                <p style={{ fontSize: "1.2rem", color: "rgba(255,255,255,0.7)", marginBottom: "30px" }}>
                                    Let's discuss how our Manufacturing ERP can transform your operations.
                                </p>
                                <Link to="/contact-us" className="thm-btn agency-btn">
                                    <span className="text">Contact Us Today</span>
                                </Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default ManufacturingERPPage;
